import $ from 'jquery'

class Search {
  // 1. Describe and create or initiate our object
  constructor() {
    this.addSearchHTML()
    this.resultsDiv = $('#search-overlay__results')
    this.openButton = $('.js-search-trigger')
    this.mobileOpenButton = $('.js-search-trigger-2')
    this.closeButton = $('.search-overlay__close')
    this.searchOverlay = $('.search-overlay')
    this.searchField = $('#search-term')
    this.events()
    this.isOverlayOpen = false
    this.isSpinnerVisible = false
    this.previousValue
    this.typingTimer
  }

  // 2. Events
  events() {
    this.mobileOpenButton.on('click', this.openOverlay.bind(this))
    this.openButton.on('click', this.openOverlay.bind(this))
    this.closeButton.on('click', this.closeOverlay.bind(this))
    $(document).on('keydown', this.keyPressDispatcher.bind(this))
    this.searchField.on('keyup', this.typingLogic.bind(this))
  }

  // 3. Methods (function, action...)
  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer)
      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html('<div class="spinner-loader"></div>')
          this.isSpinnerVisible = true
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750)
      } else {
        this.resultsDiv.html('')
        this.isSpinnerVisible = false
      }
    }

    this.previousValue = this.searchField.val()
  }

  getResults() {
    if (!this.isSpinnerVisible) {
      this.resultsDiv.html('<div class="spinner-loader"></div>')
      this.isSpinnerVisible = true
    }
    $.getJSON(thinqkData.root_url + '/wp-json/thinqk/v1/search?term=' + this.searchField.val(), results => {
      this.resultsDiv.html(`
        <div class="row">
          <div class="col-12">
            <h2 class="search-overlay__section-title mb-4">Pump parts that fit</h2>
          </div>
        </div>
            ${results.products.length ? '<div class="row">' : '<p>No general information matches that search.'}
            ${results.products
              .slice(0, 60)
              .map(
                item => `
                  <div class="col-sm-6 col-lg-4 col-xl-3 col-xxl-2 mb-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="500">
                    <div class="card" onclick="location.href='${item.permalink}'">
                      <img src="https://shop.thinqk.com/_clientfiles/products/${item.image_big}" class="card-img-top" alt="${item.title}">
                      <div class="card-body">
                        <div class="card-body__left">
                          <h5 class="card-title">${item.title}</h5>
                        </div>
                        <div class="card-body__right">
                          <a href="${item.permalink}" class="btn stretched-link"><svg xmlns="http://www.w3.org/2000/svg" width="11.776" height="20" viewBox="0 0 11.776 20">
                              <path id="Path_17" data-name="Path 17" d="M223.253,52.1l5.211-9.683c.616-.091,1.153-.15,1.6-.18s.911-.041,1.387-.041c.226,0,.482,0,.77.014s.571.027.848.057l.8.083.66.068-5.272,9.438,5.764,10.094a12.521,12.521,0,0,1-1.4.18c-.586.043-1.114.068-1.593.068-.6,0-1.172-.024-1.727-.068a13.494,13.494,0,0,1-1.418-.18Z" transform="translate(235.029 62.193) rotate(180)"></path>
                            </svg></a>
                        </div>
                      </div>
                    </div>
                  </div>`
              )
              .join('')}
            ${results.products.length ? '</div>' : ''}
      `)
      this.isSpinnerVisible = false
    })
  }

  keyPressDispatcher(e) {
    if (e.keyCode == 83 && !this.isOverlayOpen && !$('input, textarea').is(':focus')) {
      this.openOverlay()
    }
    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeOverlay()
    }
  }

  openOverlay() {
    // Check if menu is open
    if ($('body').hasClass('menu-open')) {
      console.log('close menu')
      $('#navi-toggle').prop('checked', false)
      $('#navBack').css('transform', 'scale(0)')
      $('#body').css('overflowY', 'visible')
    }

    this.searchOverlay.addClass('search-overlay--active')
    $('body').addClass('body-no-scroll')
    this.searchField.val('')
    setTimeout(() => this.searchField.focus(), 301)
    // console.log('Open')
    this.isOverlayOpen = true
    return false
  }

  closeOverlay() {
    this.searchOverlay.removeClass('search-overlay--active')
    $('body').removeClass('body-no-scroll')
    // console.log('Close')
    this.isOverlayOpen = false
  }

  addSearchHTML() {
    $('body').append(`
      <div class="search-overlay">
        <div class="search-overlay__top">
          <div class="container">
            <svg xmlns="http://www.w3.org/2000/svg" class="search-overlay__icon" width="18" height="18" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" /></svg>
            <input type="text" class="search-term" placeholder="Search for pump parts?" id="search-term">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" class="search-overlay__close" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/><path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/></svg>
          </div>
        </div>
        <div class="container">
          <div id="search-overlay__results"></div>
        </div>
      </div>
    `)
  }
}
export default Search
